import React,{useState,useEffect} from 'react'
import Loader from '../../components/Loader'
import VideoModal from './videoModal';
import axios from 'axios';

const Index = () => {
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);
    const [error, setError] = useState('');
    const [modalShow, setModalShow] = useState(false);
    const API_KEY = 'AIzaSyCtSn1hf7m3D-eMfFwBowXqiBbeQvYwYUY&playlistId=PLVfnU7aElMOQR3_SrJ23EKU5ePvoyNvca';
    const BASE_URL = 'https://www.googleapis.com/youtube/v3';
    const [show, setShow] = useState(false);
    const [modalContent, setModalContent] = useState('');

    const handleClose = () => setShow(false);
    const handleShow = (content) => {
        setModalContent(content);
        setShow(true);
    };
    

    const fetchVideos = async () => {
        try {
          const response = await axios.get(`${BASE_URL}/playlistItems?key=${API_KEY}&part=contentDetails,id,snippet,status&maxResults=50`);
          console.log(response.data.items)
          //return response.data.items;
          setItems(response.data.items)
          setLoading(false)
        } catch (error) {
          console.error('Error fetching videos:', error);
          setError(error)
          setLoading(false);
          //return [];
        }
      };

    useEffect(() => {        
     
        fetchVideos(); // Call the function to fetch data when the component mounts
        return () => {
            setItems([]);
            setLoading(true);
            setError('')
        }
    }, []); // The empty dependency array ensures it only runs once
    if (loading) {
        return <Loader />
    }
    return (
        <div className='inner-wrapper'>

            {/* <BannerInner /> */}
            <>

                <div className='inner-wrapper'>
                    <div className='container'>
                        <div className='top-heading flex justify-between'>
                            <h1 className='site-color-dark-red'>Videos</h1>                            
                        </div>

                        <div className='videoWrap'>
                        {items && items.map((item, index) => (
                                                
                            <div className='itemWrap' key={index}>
                                <div className='thumbnail' onClick={() => handleShow({title:item.snippet.title,url:item.snippet.resourceId.videoId})}>
                                    <img src={item.snippet.thumbnails.standard.url} />
                                </div>
                                <h3>{item.snippet.title}</h3>
                            </div>
                        ))}
                            
                        </div>
                       
                    </div>
                </div>

            </>
            <VideoModal  dialogClassName="modal-90w" aria-labelledby="contained-modal-title-vcenter" centered size="lg" show={show} handleClose={handleClose} modalContent={modalContent} />
        </div>
    )
}

export default Index